import { Component, OnInit } from '@angular/core';
import { tap } from 'rxjs';
import { ApiUrls } from 'src/app/shared/const/Api-urls';
import {
  PageCategoryCO,
  PageCategoryType,
  PageCO
} from 'src/app/shared/models/ApiModels';
import { PageDataService } from 'src/app/shared/services/page-data.service';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit {

  loading$ = this.pageDataService.loading$;
  error$ = this.pageDataService.error$;

  aboutImages: string[] = [];

  aboutInstitution?: PageCategoryCO;
  aimCategory?: PageCategoryCO;
  missionCategory?: PageCategoryCO;
  visionCategory?: PageCategoryCO;

  constructor(private pageDataService: PageDataService) {}

  ngOnInit(): void {
    this.pageDataService.loadPageData();
  }

  pageData$ = this.pageDataService.pageData$.pipe(
    tap(data => {
      if (!data?.length) return;

      const aboutPage = data.find(
        page => page?.name?.toLowerCase() === 'about us'
      );

      if (!aboutPage) return;

      this.extractImages(aboutPage);
    })
  );

  private extractImages(page: PageCO): void {
    if (!page.category?.length) return;

    const categoryMap = new Map<PageCategoryType, PageCategoryCO>();
    page.category.forEach(cat =>
      categoryMap.set(cat.category, cat)
    );

    this.aboutInstitution =
      categoryMap.get(PageCategoryType.ABOUT_US_INSTITUTION_QUALITY);

    this.aimCategory =
      categoryMap.get(PageCategoryType.ABOUT_US_AIM);

    this.missionCategory =
      categoryMap.get(PageCategoryType.ABOUT_US_MISSION);

    this.visionCategory =
      categoryMap.get(PageCategoryType.ABOUT_US_VISION);

    this.aboutImages = this.buildImageList(this.aboutInstitution);
  }

  private buildImageList(category?: PageCategoryCO): string[] {
    return (
      category?.image?.map(img =>
        this.getFileUrl(img.file.fileUUID)
      ) ?? []
    );
  }

  getImage(category?: PageCategoryCO, fallback: string = ''): string {
    return category?.image?.[0]?.file?.fileUUID
      ? this.getFileUrl(category.image[0].file.fileUUID)
      : fallback;
  }

  private getFileUrl(uuid: string): string {
    return `${ApiUrls.downloadFileUrl1}${uuid}`;
  }
}